<template>
  <div class="row">
    <div class="col-lg-2">
      <input type="text" class="form-control" v-model="filters['name']" placeholder="Name" @keydown.enter="filterUsers">
    </div>
    <div class="col-lg-2">
      <div class="col-lg-12">
        <v-select placeholder="Clients" :options="f.clients" multiple label="name" index="id" v-model="filters['clients']"
                  @input="filterUsers"></v-select>
      </div>
    </div>
    <div class="col-lg-2">
      <div class="col-lg-12">
        <v-select placeholder="Departments" :options="departments" multiple v-model="filters['departments']" index="index"
                  @input="filterUsers"></v-select>
      </div>
    </div>
    <div class="col-lg-2">
      <div class="col-lg-12">
        <v-select placeholder="Roles" :options="userRoles" multiple v-model="filters['roles']"
                  @input="filterUsers"></v-select>
      </div>
    </div>
    <div class="col-lg-2">
      <div class="col-lg-12">
        <v-select placeholder="Admin Status" :options="adminStatus" index="index" label="txt" v-model="filters['admin']" @input="filterUsers"></v-select>
      </div>
    </div>
    <div class="col-lg-2">
      <div class="col-lg-12">
        <v-select placeholder="Active Status" :options="activeStatus" index="index" label="txt" v-model="filters['active']" @input="filterUsers"></v-select>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Query } from '../../../../mixins/helperMixin'
import axios from 'axios'

export default {
  data () {
    return {
      filters: {active: true},
      multiFilters: {},
      showCompleted: false,
      adminStatus: [
        {index: null, txt: 'All'},
        {index: true, txt: 'Admin'},
        {index: false, txt: 'Not Admin'}
      ],
      activeStatus: [
        {index: null, txt: 'All'},
        {index: true, txt: 'Active'},
        {index: false, txt: 'Not Active'}
      ],
      departments: []
    }
  },
  mixins: [Query],
  computed: {
    ...mapGetters({
      f: 'getFilters',
      users: 'getUsers',
      userRoles: 'getUserRoles'
    })
  },
  mounted () {
    this.$store.dispatch('loadUsers', this.buildQuery(this.filters))
    this.loadDepartments()
  },
  methods: {
    filterUsers () {
      this.$store.dispatch('loadUsers', this.buildQuery(this.filters))
    },
    async loadDepartments () {
      try {
        this.departments = (await axios.get(`/v2/data-structures/departments`)).data.values
      } catch (e) {}
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Users/Filters.vue